export default {
  PASSENGERS: 'PASSENGERS',
  PAYMENT: 'PAYMENT',
  CONFIRM: 'CONFIRM',
}
